const lineColor = '#eee'
const textColor = '#999'

const SERIES_COLOR = {
  discharge: '#00A2FF',
  charge: '#2CD095',
  net: '#FF7A45',
}

function toNum(value) {
  if (value === null || value === undefined || value === '') return null
  const num = Number(value)
  return Number.isNaN(num) ? null : num
}

function round(value, frac = 2) {
  const num = toNum(value)
  return num === null ? null : Number(num.toFixed(frac))
}

/**
 * 现货电能量图表 option。
 *
 * 现货没有尖峰平谷分段，原来的 5 段堆叠不适用。改为对称双向柱状：
 * 放电向上、充电向下（取负绘制、tooltip 显示绝对值）。
 *
 * @param {Array} rows normalizeSpotRows 加工后的行
 * @param {'15min'|'hour'|'day'} granularity
 */
export function getSpotKwhChartOption(rows = [], granularity = '15min') {
  const xData = rows.map((r) => r._label)

  const dischargeData = rows.map((r) => round(r.dischargeEnergy))
  // 充电取负，做成对称双向柱
  const chargeData = rows.map((r) => {
    const v = round(r.chargeEnergy)
    return v === null ? null : -v
  })

  return {
    grid: { left: '1%', right: '1%', top: '18%', bottom: rows.length > 48 ? '16%' : '10%', containLabel: true },
    legend: {
      show: true,
      top: 0,
      right: 0,
      icon: 'circle',
      itemWidth: 8,
      textStyle: { fontFamily: 'HarmonyOS Sans SC', color: textColor, fontSize: 12 },
      data: ['放电量', '充电量'],
    },
    xAxis: {
      type: 'category',
      data: xData,
      axisLabel: {
        color: textColor,
        fontSize: 10,
        interval: 'auto',
        hideOverlap: true,
        formatter: (val) => (granularity === 'day' ? val : String(val).slice(-5)),
      },
      axisTick: { show: false },
      axisLine: { show: false, lineStyle: { color: lineColor } },
    },
    yAxis: {
      type: 'value',
      name: '电量(kWh)',
      nameTextStyle: { fontFamily: 'HarmonyOS Sans SC', color: textColor, align: 'center' },
      splitLine: { lineStyle: { color: lineColor, type: 'dashed' } },
      // 充电为负值，y 轴标签显示绝对值，避免误读成负电量
      axisLabel: { color: textColor, fontSize: 10, formatter: (val) => Math.abs(val) },
      axisLine: { show: false, lineStyle: { color: lineColor } },
      splitNumber: 6,
    },
    tooltip: {
      show: true,
      trigger: 'axis',
      axisPointer: { type: 'shadow' },
      className: 'chart-tooltip',
      backgroundColor: '#ffffff',
      borderColor: 'rgba(15, 23, 42, 0.06)',
      hideDelay: 0,
      enterable: false,
      formatter(params) {
        if (!params || !params.length) {
          return '<div class="chart-tooltip__items-container">暂无数据</div>'
        }
        const time = params[0].name
        let html = `<div class="chart-tooltip__time">时间: ${time}</div><div class="chart-tooltip__items-container">`
        params.forEach((p) => {
          const raw = p.value
          // 充电是取负绘制的，展示时还原成正值
          const shown = raw === null || raw === undefined ? '--' : `${Math.abs(raw)} kWh`
          html += `
            <div class="chart-tooltip__series">
              <div class="chart-tooltip__point" style="background: ${p.color}"></div>
              <div class="chart-tooltip__series-name">${p.seriesName}: </div>
              <div class="chart-tooltip__value">${shown}</div>
            </div>`
        })
        html += '</div>'
        return html
      },
    },
    axisPointer: { link: { xAxisIndex: 'all' }, label: { backgroundColor: '#777' } },
    dataZoom: rows.length > 48
      ? [{ type: 'inside' }, { type: 'slider', height: 16, bottom: 4 }]
      : [{ type: 'inside' }],
    series: [
      {
        name: '放电量',
        type: 'bar',
        stack: 'energy',
        barMaxWidth: 10,
        itemStyle: { color: SERIES_COLOR.discharge },
        data: dischargeData,
      },
      {
        name: '充电量',
        type: 'bar',
        stack: 'energy',
        barMaxWidth: 10,
        itemStyle: { color: SERIES_COLOR.charge },
        data: chargeData,
      },
      // 净电量折线按业务要求隐藏
    ],
  }
}
